//store/modules/fundraiser.js

import axios from './axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API
const state = {
  fundraisers: {},
  fundraiserSummary: {},
  fundraiserDonations: {},
  fundraiserCashouts: {},
  fundraiserExpenses: {},
  fundUpdateResponse: {},
  patrons: {},
  webData: {},
  statementSummary: {},
}
const getters = {
  userCampaigns: (state) => state.fundraisers,
  fundraiserSummary: (state) => state.fundraiserSummary,
  fundraiserDonations: (state) => state.fundraiserDonations,
  fundraiserCashouts: (state) => state.fundraiserCashouts,
  fundraiserExpenses: (state) => state.fundraiserExpenses,
  patrons: (state) => state.patrons,
  webData: (state) => state.webData,
  statementSummary: (state) => state.statementSummary,
}
const actions = {
  async GetFundraisers({ commit }, user) {
    let response = await axios.post('/portal/user/user-data', user)
    if (user.step == 5) {
      await commit('setFundraisers', response.data)
    } else {
      await commit('setResponse', response.data)
    }
    return response.data
  },

  async GetStatementSummary({ commit }, stat_dets) {
    let response = await axios.post('/service/portal/statement-keys', stat_dets)
    await commit('setStatementSummary', response.data)
    return response.data
  },

  async GetFundraiserSummary({ commit }, campaign_id) {
    let response = await axios.post('/service/portal/summary', {
      campaign_id: campaign_id,
    })
    await commit('setFundraiserSummary', response.data)
    return response.data
  },

  async GetFundraiserDonations({ commit }, campaign_id) {
    let response = await axios.post('/service/web_fundraiser/transactions', {
      campaign_id: campaign_id,
      order: {
        id: 'desc',
      },
      limit: {
        offset: 0,
        limit: 10,
      },
      columns: [
        'payer_name',
        'paying_msisdn contact',
        'converted_amount amount',
        'transact_id',
        'payment_type',
        'payment_date',
      ],
      keys: {
        campaign_id: campaign_id,
      },
    })
    await commit('setResponse', response.data)
    return response.data
  },
  async GetFundraiserCashouts({ commit }, campaign_id) {
    let response = await axios.post('/portal/fundraiser/cashouts', {
      campaign_id: campaign_id,
      order: {
        id: 'desc',
      },
      limit: {
        offset: 0,
        limit: 10,
      },
      columns: [
        'cashout_amount_converted amount',
        'transfer_fee_converted transfer_fee',
        'mchanga_fee_converted mchanga_fee',
        'acct_balance_converted balance',
        'receiver_msisdn',
        'partial',
        'partial_text',
        'cashout_method',
        'DATE_FORMAT(cashout_date,"%Y-%m-%d %H:%i") cashout_date',
        'processed',
      ],
      keys: {
        campaign_id: campaign_id,
      },
    })
    await commit('setFundraiserCashouts', response.data)
  },
  async GetFundraiserExpenses({ commit }, campaign_id) {
    let response = await axios.post('/service/fundraiser/expensesP', {
      campaign_id: campaign_id,
      order: {
        id: 'desc',
      },
      limit: {
        offset: 0,
        limit: 10,
      },
      columns: [
        'expence',
        'expense_reference',
        'converted_amount amount',
        'currency',
        'DATE_FORMAT(expence_date,"%Y-%m-%d %H:%i") expence_date',
      ],
      keys: {
        campaign_id: campaign_id,
      },
    })
    await commit('setFundraiserExpenses', response.data)
  },

  async updateFundraiserInfo({ commit }, fund) {
    let response = await axios.post('/portal/fundraiser/update_info', fund)
    await commit('setResponse', response.data)
    return response.data
  },

  async getFundWebData({ commit }, campaign_id) {
    let response = await axios.post(
      'service/fundraiser/share-page-detailsP',
      campaign_id,
    )
    await commit('setWebData', response.data)
    return response.data
  },

  async addFundWebData({ commit }, fundData) {
    let response = await axios.post('/service/fundraiser/add_data', fundData)
    await commit('setResponse', response.data)
    return response.data
  },

  async addPatron({ commit }, patronData) {
    let response = await axios.post('/service/fundraiser/addPatron', patronData)
    await commit('setResponse', response.data)
    return response.data
  },
  async getPatrons({ commit }, campaign_id) {
    let response = await axios.post(
      'service/fundraiser/getPatrons',
      campaign_id,
    )
    await commit('setPatrons', response.data)
    return response.data
  },
  async deletePatron({ commit }, patron) {
    let response = await axios.post(
      'service/fundraiser/retire_detailsP',
      patron,
    )
    await commit('setResponse', response.data)
    return response.data
  },
  async approvePatron({ commit }, patron) {
    let response = await axios.post('portal/fundraiser/patron-verify', patron)
    await commit('setResponse', response.data)
    return response.data
  },
  async getBlastSummary({ commit }, campaign) {
    let response = await axios.post(
      '/service/fundraiser/donor-summary',
      campaign,
    )
    await commit('setResponse', response.data)
    return response.data
  },
  async sendDonorUpdate({ commit }, campaign) {
    let response = await axios.post(
      '/service/fundraiser/donor-update',
      campaign,
    )
    await commit('setResponse', response.data)
    return response.data
  },
  async getStatementData({ commit }, campaign) {
    try {
      let response = await axios.post(
        '/service/fundraiser/getStatData',
        campaign,
        { timeout: 120000 },
      )
      await commit('setResponse', response.data)
      return response.data
    } catch (error) {
      console.log(error)
    }
  },
  async getEmailData({ commit }, email) {
    let response = await axios.post('/service/fundraiser/check_email', email)
    await commit('setResponse', response.data)
    return response.data
  },
  async logSurvey({ commit }, surveyData) {
    let response = await axios.post(
      '/service/fundraiser/feedbackSurvey',
      surveyData,
    )
    await commit('setResponse', response.data)
    return response.data
  },
  async fundProgress({ commit }, params) {
    try {
      let response = await axios.post(
        '/portal/fundraiser/account-progress',
        params,
      )
      await commit('setResponse', response.data)
      return response.data
    } catch (error) {
      console.log(error)
    }
  },
  async deleteFundraiser({ commit }, params) {
    let response = await axios.post(
      '/service/fundraiser/delete-inactive-fundraiser',
      params,
    )
    await commit('setResponse', response.data)
    return response.data
  },
  async restoreEmail({ commit }, params) {
    let response = await axios.post('/service/email/restore', params)
    await commit('setResponse', response.data)
    return response.data
  },
}
const mutations = {
  setWebData(state, response) {
    state.webData = response
  },
  setPatrons(state, response) {
    if ('Empty' in response) {
      state.patrons = {}
    } else {
      state.patrons = response
    }
  },
  setFundraisers(state, response) {
    state.fundraisers = response
  },
  setFundraiserSummary(state, response) {
    state.fundraiserSummary = response
  },
  setFundraiserCashouts(state, response) {
    state.fundraiserCashouts = response
  },
  setFundraiserExpenses(state, response) {
    state.fundraiserExpenses = response
  },
  setResponse(state, response) {
    response = {}
    state.fundUpdateResponse = response
  },
  setStatementSummary(state, response) {
    state.statementSummary = response
  },
}
export default {
  state,
  getters,
  actions,
  mutations,
}
